

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
// eslint-disable-next-line
import * as _ from './firebaseconfig';
import App from "App";
// Ajce Hostel App React Context Provider
import { MaterialUIControllerProvider } from "context";

ReactDOM.render(
  <BrowserRouter>
    <MaterialUIControllerProvider>
      <App />
    </MaterialUIControllerProvider>
  </BrowserRouter>,
  document.getElementById("root")
);
